module.exports = __webpack_public_path__ + "img/weixin-3.74b0e743.png";